import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves pricing methods
*/

export function getPricingMethods(_this) {
    gatewayService.catalogs
    .pricingMethods({ format: "json" })
    .then(data => {
        _this.pricingMethods = data;
        let txt = "One of the following: ";
        _this.pricingMethods.forEach((d, i) =>
          i < _this.pricingMethods.length - 1
            ? (txt += d.name + ", ")
            : (txt += d.name + ".")
        );
      })
      .catch(function(error) {
        console.log(error);
      });
  }
